import styles from './footer-demo-section.css?url'
export const links = () => [{ rel: 'stylesheet', href: styles }]
export { FooterDemoSection } from './footer-demo-section'
